import type { ToasterProps } from 'react-hot-toast';

import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { Toaster } from 'react-hot-toast';

import useClassy from '@core/hooks/useClassy';
import useEnvInfo from '@core/hooks/useEnvInfo';

import styles from './Toaster.module.scss';

const PortalToaster = ({ containerStyle, ...rest }: ToasterProps) => {
  const bem = useClassy(styles, 'Toaster');
  const { isClient } = useEnvInfo();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  // Skip rendering for SSR
  if (!mounted || !isClient) return null;

  return ReactDOM.createPortal(
    <Toaster
      containerClassName={bem()}
      containerStyle={{
        // Intentionally undefined so we can set z-index in scss.
        zIndex: undefined,
        ...containerStyle,
      }}
      {...rest}
    />,
    document.body,
  );
};

export default PortalToaster;
